import { Link } from "react-router-dom";

const FooterMinimal = () => {
  return (
    <footer className="bg-background border-t border-border">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-10 py-10 sm:py-14 md:py-12">
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-7 gap-6 sm:gap-8 md:gap-6">
          <div>
            <p className="text-foreground font-medium text-[13px] mb-3 sm:mb-4 text-body">Products</p>
            <ul className="space-y-1.5 sm:space-y-2">
              {[
                { to: "/product", label: "Overview" },
                { to: "/clinic-genius-ai", label: "Clinic Genius AI" },
                { to: "/products/voice", label: "Astreon Voice" },
                { to: "/products/flow", label: "Astreon Flow" },
                { to: "/products/insights", label: "Astreon Insights" },
                { to: "/products/engage", label: "Astreon Engage" },
                { to: "/products/custom", label: "Astreon Custom" },
              ].map((link) => (
                <li key={link.label}>
                  <Link to={link.to} className="text-muted-foreground hover:text-foreground transition-colours text-[12px] sm:text-[13px] text-body">{link.label}</Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="text-foreground font-medium text-[13px] mb-3 sm:mb-4 text-body">Industries</p>
            <ul className="space-y-1.5 sm:space-y-2">
              {[
                { to: "/industries/healthcare", label: "Healthcare" },
                { to: "/industries/logistics", label: "Logistics" },
                { to: "/industries/real-estate", label: "Real estate" },
                { to: "/industries/law-firms", label: "Law Firms" },
                { to: "/industries/ecommerce", label: "E-commerce" },
                { to: "/industries/finance", label: "Finance" },
                { to: "/industries/construction", label: "Construction" },
                { to: "/industries/hospitality", label: "Hospitality" },
                { to: "/industries/education", label: "Education" },
                { to: "/industries/manufacturing", label: "Manufacturing" },
                { to: "/industries/insurance", label: "Insurance" },
                { to: "/industries/travel-tourism", label: "Travel & Tourism" },
                { to: "/industries/recruitment", label: "Recruitment" },
                { to: "/industries/it-enterprises", label: "IT and operational enterprises" },
              ].map((link) => (
                <li key={link.label}>
                  <Link to={link.to} className="text-muted-foreground hover:text-foreground transition-colours text-[12px] sm:text-[13px] text-body">{link.label}</Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="text-foreground font-medium text-[13px] mb-3 sm:mb-4 text-body">Customers</p>
            <ul className="space-y-1.5 sm:space-y-2">
              <li><Link to="/case-studies" className="text-muted-foreground hover:text-foreground transition-colours text-[12px] sm:text-[13px] text-body">Case studies</Link></li>
            </ul>
          </div>
          <div>
            <p className="text-foreground font-medium text-[13px] mb-3 sm:mb-4 text-body">Join us</p>
            <ul className="space-y-1.5 sm:space-y-2">
              <li><Link to="/careers" className="text-muted-foreground hover:text-foreground transition-colours text-[12px] sm:text-[13px] text-body">Careers</Link></li>
            </ul>
          </div>
          <div>
            <p className="text-foreground font-medium text-[13px] mb-3 sm:mb-4 text-body">Certified</p>
            <ul className="space-y-1.5 sm:space-y-2">
              <li>
                <Link to="/trust-center" className="text-foreground hover:text-muted-foreground transition-colours text-[12px] sm:text-[13px] font-medium underline underline-offset-4 text-body">Trust Centre →</Link>
              </li>
            </ul>
          </div>
          <div>
            <p className="text-foreground font-medium text-[13px] mb-3 sm:mb-4 text-body">Company</p>
            <ul className="space-y-1.5 sm:space-y-2">
              {[
                { to: "/about", label: "About", external: false },
                { to: "/contact-us", label: "Contact us", external: false },
                { to: "https://www.linkedin.com/company/astreon-ai-group/", label: "LinkedIn", external: true },
                { to: "https://www.instagram.com/astreonaigroup?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==", label: "Instagram", external: true },
              ].map((link) => (
                <li key={link.label}>
                  {link.external ? (
                    <a href={link.to} target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colours text-[12px] sm:text-[13px] text-body">{link.label}</a>
                  ) : (
                    <Link to={link.to} className="text-muted-foreground hover:text-foreground transition-colours text-[12px] sm:text-[13px] text-body">{link.label}</Link>
                  )}
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="text-foreground font-medium text-[13px] mb-3 sm:mb-4 text-body">Legal</p>
            <ul className="space-y-1.5 sm:space-y-2">
              {[
                { to: "/terms-of-use", label: "Terms" },
                { to: "/privacy-policy", label: "Privacy Policy" },
                { to: "/security", label: "Security Policy" },
              ].map((link) => (
                <li key={link.label}>
                  <Link to={link.to} className="text-muted-foreground hover:text-foreground transition-colours text-[12px] sm:text-[13px] text-body">{link.label}</Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="mt-8 sm:mt-12 flex justify-center">
          <p
            className="font-display font-semibold tracking-[0.1em] leading-none text-center text-primary"
            style={{ fontSize: "clamp(1.8rem, 4.5vw, 4rem)" }}
          >
            ASTREON AI GROUP
          </p>
        </div>
        <div className="mt-16 sm:mt-20 md:mt-24 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-[12px] sm:text-[13px] text-muted-foreground text-body">
          <div className="flex flex-wrap items-center gap-x-5 gap-y-2">
            <Link to="/terms-of-use" className="hover:text-foreground transition-colours">Terms of use</Link>
            <Link to="/privacy-policy" className="hover:text-foreground transition-colours">Privacy Policy</Link>
            <Link to="/security" className="hover:text-foreground transition-colours">Security Policy</Link>
          </div>
          <div className="flex flex-wrap items-center gap-x-5 gap-y-2">
            <a href="https://www.linkedin.com/company/astreon-ai-group/" target="_blank" rel="noopener noreferrer" className="hover:text-foreground transition-colours">LinkedIn</a>
            <a href="https://www.instagram.com/astreonaigroup?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank" rel="noopener noreferrer" className="hover:text-foreground transition-colours">Instagram</a>
          </div>
          <p className="md:text-right">© 2026 Astreon. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default FooterMinimal;
